import { useQuery } from "@apollo/client";
import { GET_SLIDERS_CAMPAIGNS } from "./queries";

export const useGetCampaigns = () => {
  const { data, loading } = useQuery(GET_SLIDERS_CAMPAIGNS);

  return {
    loading,
    campaigns: data?.getCurrentSliderCampaign?.sliders ?? []
  };
};
